import { LinkProps } from 'next/link';

type ButtonVariant =
  | 'primary'
  | 'secondary'
  | 'tertiary'
  | 'mva:primary'
  | 'mva:secondary'
  | 'mva:alt1';

export enum IActionType {
  CUSTOM_URL = 1,
  CALL_ME_NOW = 4,
  COVERAGE_TOOL = 5,
  LOCAL_URL = 7,
  SHOW_DETAIL = 9,
  COVERAGE_TOOL_WITH_REDIRECT = 10,
  CHECKOUT_MODAL_MOBILE = 11,
  WHATSAPP_URL = 12,
  RETRY = 13,
  POPUP_DETAIL = 14,
  LEAD_MODAL = 15,
  POST_COVERAGE = 16,
  IFRAME_URL = 17,
  CALL_ME_NOW_SUNRISE = 18,
  DEACTIVATION_MODAL = 20,
  POST_ENRG = 21,
  HUB_CATALOG_ACT = 22,
  CLICK_TO_CALL_ENERGY = 24,
  ENERGY_FUNNEL = 25,
  AUTO_COVERAGE = 23,
  PARTNERSHIP_OFFER_ACTION = 26,
}

export enum IActionStyle {
  PRIMARY = 1,
  SECONDARY = 2,
  TERTIARY = 3,
}

export interface IActionSlide {
  title?: string;
  descriptionModal?: string;
  type?: IActionType;
  small?: boolean;
  url?: string;
  localUrl?: string;
  callMeNow?: string;
  isBlank?: string | boolean;
  isForApp?: string;
  onClick?: (el: unknown) => void;
  template?: string;
  key?: string;
  overrideDesc?: string;
  description?: string;
}

export interface IActionCustom extends IActionSlide {
  style?: IActionStyle;
}

export interface IActionSunrise extends IActionSlide {
  style?: ButtonVariant;
}

export interface IActionProps {
  onClick?: () => void;
  href?: LinkProps['href'];
  target?: React.HTMLAttributeAnchorTarget;
}

